import { render, staticRenderFns } from "./TopFundsOpportunitiesView.vue?vue&type=template&id=11939748&scoped=true"
import script from "./TopFundsOpportunitiesView.vue?vue&type=script&lang=js"
export * from "./TopFundsOpportunitiesView.vue?vue&type=script&lang=js"
import style0 from "./TopFundsOpportunitiesView.vue?vue&type=style&index=0&id=11939748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11939748",
  null
  
)

export default component.exports